import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { compare, isEmpty, isPresent } from '@ember/utils';

class TasksByContactItem {
  contact;
  lastCompleted = null;
  @tracked recentCompleted = [];
  @tracked notComplete = [];
  @tracked additionalCompletedTasksCount = 0;

  constructor({ contact, additionalCompletedTasksCount }) {
    this.contact = contact;
    this.additionalCompletedTasksCount = additionalCompletedTasksCount;
  }

  get allTasks() {
    return this.recentCompleted.concat(this.notComplete);
  }

  afterTaskSaved() {
    let { allTasks } = this;
    this.recentCompleted = allTasks
      .filter((task) => isPresent(task.completedDate))
      .sort((a, b) => compare(b.completedDate, a.completedDate));
    this.lastCompleted = this.recentCompleted[0];

    this.notComplete = allTasks
      .filter((task) => isEmpty(task.completedDate))
      .sort((a, b) => {
        if (isEmpty(a.dueDate) || isEmpty(b.dueDate)) {
          return -1;
        }
        return compare(a.dueDate, b.dueDate);
      });
  }
}

export default class TasksByContactRoute extends Route {
  @service contactsCache;
  @service navbarSettings;
  @service store;
  @service taskService;

  beforeModel() {
    set(this, 'navbarSettings.title', 'Tasks by Contact');
  }

  async model() {
    await this.taskService.load();
    let recentCompletedTasks = await this.store.query('v2-task', {
      filter: {
        recent_completed_for_each_contact: true,
        fund_ids: ['selected'],
      },
    });
    let additionalCompletedTasksCountByContactId =
      recentCompletedTasks.meta.additional_completed_tasks_count_by_contact_id;

    let notCompletedTasks = await this.store.query('v2-task', {
      filter: { completed: 'Not Complete', fund_ids: ['selected'] },
      sort: 'due_date',
    });

    let itemsByContactId = {};
    this.contactsCache.contacts.forEach((contact) => {
      itemsByContactId[contact.id] = new TasksByContactItem({
        contact,
        additionalCompletedTasksCount:
          additionalCompletedTasksCountByContactId[contact.id],
      });
    });

    recentCompletedTasks.slice().forEach((task) => {
      if (itemsByContactId[task.contactId]) {
        itemsByContactId[task.contactId].recentCompleted.push(task);
        if (itemsByContactId[task.contactId].lastCompleted == null) {
          itemsByContactId[task.contactId].lastCompleted = task;
        }
      }
    });

    notCompletedTasks.slice().forEach((task) => {
      if (itemsByContactId[task.contactId]) {
        itemsByContactId[task.contactId].notComplete.push(task);
      }
    });

    let contactItems = [];
    this.contactsCache.contacts.forEach((contact) => {
      contactItems.push(itemsByContactId[contact.id]);
    });

    return {
      contactItems,
    };
  }
}
